// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3brha","label":"LabeledBox_label__24rG5"};